import { Component, OnInit } from "@angular/core";
import { UserService } from "../../services/user.service";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	selector: "withdrawal-lock",
	templateUrl: "./withdrawal-lock.component.html",
	styleUrls: ["./withdrawal-lock.component.scss"],
	standalone: false
})
export class WithdrawalLockComponent extends CustomModal implements OnInit, BpModalHasSave {
	public save(): void {
		this.close();
	}
	public remainingHours: number = 0;
	public waitingHours: number = 0;

	public constructor(private userService: UserService) {
		super();
	}

	public ngOnInit(): void {
		this.remainingHours = Math.round((this.userService.user.getWithdrawAllowed().getUnix() - Date.now()) / 3600000);
		this.waitingHours = this.userService.user.withDrawLockHours();
	}
}
